var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"infinite-scroll "},[_vm._t("default"),_c('div',{ref:"spy",staticClass:"infinite-scroll-spy",attrs:{"aria-hidden":"true"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }